import { render, staticRenderFns } from "./disenos.vue?vue&type=template&id=3dc02842"
import script from "./disenos.vue?vue&type=script&lang=ts"
export * from "./disenos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports